import { Shape } from "@antv/g6/es";
import { cloneDeep, sum } from "lodash-es";
import addIcon from "@/assets/icons/edit-node-icon.svg";
import deleteIcon from "@/assets/icons/delete-node-icon.svg";

const lineDash = [40, 20, 10, 20];
const deratLength = sum(lineDash);

// FLOW-DOC: 自定义 cubic-vertical 进行扩展
// 必须是实例方法，否则不会调用

const baseEdgeDefinition = {
  buttonStyle: {
    width: 20,
    height: 20,
    radius: 3,
    cursor: "pointer",
    // FLOW-DOC:: hover 按钮的间距
    // gap: 4,
    gap: 0,
  },
  buttonBackground: {
    base: "#ffffff",
    hover: "#ddd",
    click: "#eee",
  },
  iconMaps: {
    // 可以是网络图片
    copy: "https://desk.qcloud.com/assets/setting_light-Cg6-bVTl.svg",
    add: addIcon,
    delete: deleteIcon,
  },
  // update: undefined,
  // 连线绘制完成时，实际上，触发时机在开始画的时候
  afterDraw(cfg, group) {},
  // draw(cfg, group) {
  //   const baseEdgeType = cfg.type.match(/custom:(.+)/)[1];
  //   let keyShape;
  //   if (baseEdgeType) {
  //     keyShape = G6.Shape.Edge.getShape(baseEdgeType).draw(cfg, group);
  //   }

  //   const position = keyShape.getPoint(0.2);
  //   console.log(position);
  //   this.drawDeleteButton(cfg, group, position);
  //   return keyShape;
  // },
  drawDeleteButton(cfg, group, position) {
    // const hoverGroup = group.addGroup({
    //   name: "edgeButton:delete-group",
    //   capture: true,
    //   zIndex: 1000,
    // });
    const hoverGroup = group;
    const name = "delete";
    hoverGroup
      .addShape("rect", {
        attrs: {
          width: this.buttonStyle.width,
          height: this.buttonStyle.height,
          radius: this.buttonStyle.radius,
          cursor: this.buttonStyle.cursor,
          fill: this.buttonBackground.base,
          lineWidth: 2,
          opacity: 0,
          ...position,
        },
        draggable: true,
        capture: true,
        zIndex: 100,
        name: `edgeButton:${name}`,
      })
      .animate(
        {
          opacity: 1,
        },
        150,
      );

    hoverGroup
      .addShape("image", {
        attrs: {
          opacity: 0,
          img: this.iconMaps[name],
          ...this.buttonStyle,
          ...position,
        },
        draggable: true,
        capture: true,
        zIndex: 150,
        name: `edgeButton:${name}-icon`,
      })
      .animate(
        {
          opacity: 1,
        },
        150,
      );
    hoverGroup.sort();
    group.sort();
  },
  setState(name, value, item) {
    const baseEdgeType = item.get("currentShape").match(/custom:(.+)/)[1];
    // hover 的 高亮， active 状态，由此处绘制
    if (baseEdgeType) {
      Shape.Edge.getShape(baseEdgeType).setState(name, value, item);
    }
    const group = item.getContainer();
    const shape = item.getKeyShape?.() || group["shapeMap"]["edge-shape"];

    // 监听 running 状态
    if (name === "running") {
      // running 状态为 true 时
      if (value) {
        let index = 0;
        // 边 path 图形的动画
        shape.animate(
          () => {
            // DESC: 动画速度， 每一帧的动画长度
            index = index + 0.4;
            if (index > deratLength) {
              index = 0;
            }
            const res = {
              lineDash,
              lineDashOffset: -index,
            };
            // 返回需要修改的参数集，这里修改了 lineDash,lineDashOffset
            return res;
          },
          {
            repeat: true, // 动画重复
            duration: 30, // 一次动画的时长为 30
          },
        );
      } else {
        // running 状态为 false 时
        // 结束动画
        shape.stopAnimate();
        // 清空 lineDash
        shape.attr("lineDash", null);
      }
    }

    // 鼠标 hover 时候 active
    // if (name === "active") {
    // }

    if (name === "updating") {
      if (value) {
        const style = item.get("styles").updating;
        shape.attr(style);
      } else {
        const style = item.getModel().style;
        shape.attr(style);
      }
    }

    if (name === "error") {
      if (value) {
        const style = item.get("styles").error;
        shape.attr(style);
      } else {
        const style = item.getModel().style;
        shape.attr(style);
      }
    }
  },
};

const edgeTypes = [
  { name: "line", extendFrom: "line" },
  { name: "polyline", extendFrom: "polyline" },
  { name: "arc", extendFrom: "arc" },
  { name: "quadratic", extendFrom: "quadratic" },
  { name: "cubic", extendFrom: "cubic" },
  { name: "cubic-vertical", extendFrom: "cubic-vertical" },
  { name: "cubic-horizontal", extendFrom: "cubic-horizontal" },
  { name: "loop", extendFrom: "loop" },
];

export const getEdgeDefineCfg = (type) => {
  const extendFrom =
    edgeTypes.find((v) => v.name === type)?.extendFrom ?? "line";
  const edgeDefinition = cloneDeep(baseEdgeDefinition);

  return {
    edgeDefinition: edgeDefinition,
    extendShapeType: extendFrom,
  };
};
